import React from 'react'
import {FormattedMessage} from 'react-intl'
import PropTypes from 'prop-types'
import {
    Box,
    Image,
    useMultiStyleConfig,
    Text,
    Heading
} from '@salesforce/retail-react-app/app/components/shared/ui'

/**
 * In the context of a cart product item variant, this component renders the item's
 * engraving image/images.
 */
const ItemEngravingImage = ({engravingDetails}) => {
    const cartStyles = useMultiStyleConfig('CartStyles')

    if (!engravingDetails?.length) return

    const isOdd = engravingDetails.length % 2 === 1

    return (
        <>
            <Heading
                className="engraving-heading"
                as="h3"
                {...cartStyles.lineItems.item.engravingHeading}
            >
                <FormattedMessage id="engraving" defaultMessage="Engraving" />
            </Heading>
            <Box className="engraving-grid" {...cartStyles.lineItems.item.engravingGrid}>
                {engravingDetails.map((face, index) => {
                    const isLastSingle = isOdd && index === engravingDetails.length - 1
                    // if jobId is not available, it means the engraving job is not created successfully, we will skip showing the engraving image in this case
                    if (!face.jobId) return

                    return (
                        <Box
                            className="engraving-cell"
                            key={face.jobId || index}
                            {...cartStyles.lineItems.item.engravingCell.base}
                            {...(isLastSingle
                                ? cartStyles.lineItems.item.engravingCell.single
                                : {})}
                        >
                            <Box
                                className="engraving-image-wrapper"
                                {...cartStyles.lineItems.item.engravingImageWrapper}
                            >
                                <Image
                                    className="engraving-image"
                                    width="67px"
                                    height="84px"
                                    alt={face.faceName || 'Engraving preview'}
                                    src={face.thumbnail}
                                    ignoreFallback
                                    {...cartStyles.lineItems.item.engravingImage}
                                />
                            </Box>
                            <Text as="span" {...cartStyles.lineItems.item.engravingLabel}>
                                {face.faceName}
                            </Text>
                        </Box>
                    )
                })}
            </Box>
        </>
    )
}

ItemEngravingImage.propTypes = {
    engravingDetails: PropTypes.arrayOf(
        PropTypes.shape({
            jobId: PropTypes.string,
            faceName: PropTypes.string,
            thumbnail: PropTypes.string
        })
    )
}
export default ItemEngravingImage
